import { CircularProgress, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropertyCombination from "common/components/chartNivo/pieChart-with-legends/propertyCombination";
import { dateMiladiToShamsi } from "common/method/date";
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Description from "../description";
import { portfolioIndustriesAnalysis } from "../nlg/nlg";
import { useTheme, useMediaQuery } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

const Pie1Box = memo(({ data, tip }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const reducerportfolioIndustriesLast = useSelector(
    (state) => state.select_last_portfolio_industries_reducer,
  );
  const loadingReducer = useSelector((state) => state.loading);
  const [relatedDate, setRelatedDate] = useState("");
  const [CombineData, setCombineData] = useState([
    {
      id: "-",
      label: "-",
      value: 0,
      color: "#CCC",
      percent: "0",
    },
  ]);
  const [stock, setStock] = useState([
    {
      id: "-",
      label: "-",
      value: 1,
      color: "#CCC",
      percent: "0",
    },
  ]);

  const analysis = portfolioIndustriesAnalysis(
    reducerportfolioIndustriesLast.data,
  );

  useEffect(() => {
    if (reducerportfolioIndustriesLast?.data?.length !== 0) {
      let date = dateMiladiToShamsi(
        reducerportfolioIndustriesLast?.data[0]?.body.related_date,
      );
      setRelatedDate(date);
    }
  }, [reducerportfolioIndustriesLast?.data]);
  return (
    <>
      <div
        className="flex justify-between items-center"
        style={{ width: "max-content" }}
      >
        <h1 className="pr-3 mt-2 mx-2">ترکیب صنایع پرتفوی</h1>
        <Tooltip
          className="mt-3"
          title={
            <p className="p-2 m-0">
              {tip}
              {/* 
              <video width="300" height="200" controls autoPlay>
                <source src="/media/video/Systematic Vs Unsystematic Risk 2.mp4" type="video/mp4" />
              </video> */}
            </p>
          }
          placement={isMobile ? "bottom" : "left"}
          arrow
          classes={{ tooltip: classes.tooltip }}
          enterTouchDelay={1}
        >
          <img src="/media/image/Group 12485.png" alt="" />
        </Tooltip>
      </div>
      {relatedDate && (
        <div className="text-gray-600 text-sm mr-5">({relatedDate})</div>
      )}

      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="text-sm text-gray-700 p-5">
            این نمودار، ترکیب صنایعی که در پورتفوی فعلی روی آن‌ها سرمایه‌گذاری
            کرده‌اید را نمایش می‌دهد.
          </div>
          <Description analysis={analysis} />
        </div>
        <div className="col-span-12 lg:col-span-8">
          {/* <SummaryTable reducerselectKey={reducerselectKey} /> */}
          {loadingReducer.loading ? (
            <div className="h-full w-full flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <div className="min-h-[400px]">
              <PropertyCombination
                data={reducerportfolioIndustriesLast}
                pie1Reports
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default Pie1Box;
